export default {
      id: "left-arrow-usage",
      viewBox: "0 0 13 23",
      url: __webpack_public_path__ + "img/icons.159f8dce.svg#left-arrow",
      toString: function () {
        return this.url;
      }
    }